import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useScheme } from '../../hooks/CompanyConfiguration/useScheme'
import { formatDate, formatNumber, ROUTES } from '../../shared/constants'
import CustomViewForm from '../../components/CustomViewForm'

export default function ViewScheme() {
  const { scheme, loading, getScheme } = useScheme()
  const params = useParams()
  const [data, setData] = useState([])

  useEffect(() => {
    getScheme({ schemeId: params.schemeId })
  }, [params.schemeId])

  useEffect(() => {
    if (scheme) {
      setData([
        { label: 'Scheme Code', data: scheme.schemeCode },
        { label: 'Name', data: scheme.name },
        { label: 'Validity', data: scheme.validity },
        { label: 'Start Date', data: formatDate(scheme.schemeFrom) },
        { label: 'End Date', data: formatDate(scheme.schemeTo) },
        { label: 'Sale Amount', data: formatNumber(scheme.saleValue) },
        { label: 'Incentive', data: formatNumber(scheme.incentive) },
        { label: 'Scheme Based On', data: scheme.schemeBasedOn },
        // { label: 'Products', data: scheme.products, type: 'Array', field: 'name', field2: 'sku' },
        // { label: 'Stores', data: scheme.store, type: 'Array', field: 'name', field2: 'storeCode' },
      ])
    }
  }, [scheme])

  return (
    <Layout heading="Scheme" heading2="Info" url1={ROUTES.SCHEME} none>
      {!loading ? (
        <HeaderTabLayout
          heading="Scheme"
          content={<CustomViewForm data={data} />}
          view
          url={`/edit-scheme/${params.schemeId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}
